<template>
  <span class="progress-bar__track">
    <span
      class="progress-bar__fill"
      :style="{ width: `${clampedPercentage}%`, backgroundColor: color }"
    />
  </span>
</template>

<script>
export default {
  props: {
    percentage: { type: Number, default: 0 },
    color: { type: String, default: 'var(--w-500)' },
  },
  computed: {
    clampedPercentage() {
      return Math.min(100, Math.max(0, this.percentage || 0));
    },
  },
};
</script>

<style scoped lang="scss">
.progress-bar__track {
  background: var(--s-75);
  border-radius: var(--border-radius-normal);
  display: block;
  flex: 1;
  height: var(--space-slab);
  overflow: hidden;
}

.progress-bar__fill {
  border-radius: var(--border-radius-normal);
  display: block;
  height: 100%;
  min-width: 2px;
  transition: width 0.2s ease;
}
</style>
